import { render } from "./ReportsPanel.vue?vue&type=template&id=5034153a&ts=true"
import script from "./ReportsPanel.vue?vue&type=script&lang=ts"
export * from "./ReportsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__